<template>
  <div class="storePage">
    <div class="title">电商云店</div>
    <div class="sotreList">

      <div class="store">
        <div class="iconWrap"><img src="static/images/icon_xdj.png" alt=""></div>
        <div class="name">洗涤剂及家用护理</div>
          <a href="https://henkelhc.tmall.com/">
            <div class="storeItem">
              <div class="brand"><img class="tmall" src="static/images/icon_tmall.png" alt=""></div>
              <div>汉高家清旗舰店</div>
            </div>
          </a>
          <a href="https://shop.m.jd.com/?shopId=1000088882">
            <div class="storeItem">
              <div class="brand"><img class="jd" src="static/images/icon_jd.png" alt=""></div>
              <div>汉高家清京东自营旗舰店</div>
            </div>
          </a>
      </div>

      <div class="store">
        <div class="iconWrap"><img src="static/images/icon_hzp.png" alt=""></div>
        <div class="name">洗涤剂及家用护理</div>
          <a href="https://schwarzkopfprofessional.tmall.com/">
            <div class="storeItem">
              <div class="brand"><img class="tmall" src="static/images/icon_tmall.png" alt=""></div>
              <div>施华蔻专业官方旗舰店</div>
            </div>
          </a>
          <a href="https://shop.m.jd.com/?shopId=1000072661&utm_source=iosapp&utm_medium=appshare&utm_campaign=t_335139774&utm_term=Wxfriends&ad_od=share&gx=RnEyxGMPOWDZydQUrIF1WandY6PkeqhD">
            <div class="storeItem">
              <div class="brand"><img class="jd" src="static/images/icon_jd.png" alt=""></div>
              <div>施华蔻专业线京东自营旗舰店</div>
            </div>
          </a>
      </div>

      <div class="store">
        <div class="iconWrap"><img src="static/images/icon_nhj.png" alt=""></div>
        <div class="name">洗涤剂及家用护理</div>
          <a href="https://hangaojiancai.tmall.com/">
            <div class="storeItem">
              <div class="brand"><img class="tmall" src="static/images/icon_tmall.png" alt=""></div>
              <div>汉高建材旗舰店</div>
            </div>
          </a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'StorePage',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
  .storePage {
    width: 100%;
    min-height: 100%;
    overflow: auto;
    position: relative;
    box-sizing: border-box;
    background-color: #e10010;
    padding: 100px 40px 0 40px;

    .title {
      font-size: 44px;
      color: #fff;
    }

    .sotreList {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-top: 40px;

      .store {
        width: 668px;
        height: 324px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        background-color: #fff;
        margin-bottom: 82px;
        border-bottom-right-radius: 40px;

        a {
          text-decoration: none;
        }

        .iconWrap {
          position: absolute;
          width: 94px;
          height: 94px;
          top: -47px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          background-color: #e10010;
          border: 2px solid #fff;

          img {
            width: 60px;
            height: 60px;
          }
        }

        .name {
          font-size: 36px;
          margin-top: 70px;
          color: #282828;
        }

        .storeItem {
          width: 560px;
          height: 62px;
          display: flex;
          color: #fff;
          margin-top: 25px;
          align-items: center;
          font-size: 30px;
          background-color: #ed6670;

          .brand {
            width: 68px;
            margin-right: 30px;
            img {
              display: block;
            }
          }

          .tmall {
            width: 60px;
            height: 30px;
            // margin-right: 30px;
          }
          .jd {
            width: 68px;
            height: 30px;
            // margin-right: 30px;
          }
        }

        &:nth-child(1) {
          .brand {
            margin-left: 50px;
          }
        }

        &:nth-child(2) {
          .iconWrap {
            img {
              width: 45px;
            }
          }
          .brand {
            margin-left: 30px;
          }
        }

        &:nth-child(3) {
          height: 240px;
          margin-bottom: 0;
          .iconWrap {
            img {
              width: 35px;
            }
          }
          .storeItem {
            justify-content: center;
          }
        }

      }

    }
  }
</style>
